import { Navigate } from 'react-router-dom';

export const Redirect = () => <Navigate to="/" />;
